<template>
  <div class="Technology2">
    <div class="Technology_con_bg">
      <div class="Technology_center">
        <div class="Technology_center_title">
          <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>
        </div>

        <div class="Technology_box" v-if="TechnologyData">
          <div class="Technology_box_left">
            <div class="left_top_box" @click="toArticles(TechnologyData[0].id)">
              <img :src="`${GLOBAL.imageUrl}${TechnologyData[0].icon}`" alt />
              <p
                :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"
              >{{ TechnologyData[0].title }}</p>
              <div class="bg"></div>
            </div>
            <div class="left_bottom_box" v-if="terminal == 'pc'">
              <div class="latest">
                <div class="latest_circle">
                  <div class="dot"></div>
                  <div class="pulse"></div>
                </div>

                <div class="latest_text">{{$t('Index.Technology.latest')}}</div>
              </div>
              <div class="latest_other">
                <div class="latest_other_box">
                  <div class="latest_other_box_img" @click="toArticles(TechnologyData[3].id)">
                    <img :src="`${GLOBAL.imageUrl}${TechnologyData[3].icon}`" alt />
                    <p
                      :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"
                    >{{ TechnologyData[3].title }}</p>
                  </div>
                </div>
                <div class="latest_other_box">
                  <div class="latest_other_box_img" @click="toArticles(TechnologyData[4].id)">
                    <img :src="`${GLOBAL.imageUrl}${TechnologyData[4].icon}`" alt />
                    <p
                      :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"
                    >{{ TechnologyData[4].title }}</p>
                  </div>
                </div>
                <div class="latest_other_box">
                  <div class="latest_other_box_img" @click="toArticles(TechnologyData[5].id)">
                    <img :src="`${GLOBAL.imageUrl}${TechnologyData[5].icon}`" alt />
                    <p
                      :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"
                    >{{ TechnologyData[5].title }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="Technology_box_right">
            <div class="Technology_box_right_top" @click="toArticles(TechnologyData[1].id)">
              <img :src="`${GLOBAL.imageUrl}${TechnologyData[1].icon}`" alt />
              <p
                :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"
              >{{ TechnologyData[1].title }}</p>
              <div class="bg"></div>
            </div>
            <div class="Technology_box_right_bottom" @click="toArticles(TechnologyData[2].id)">
              <img :src="`${GLOBAL.imageUrl}${TechnologyData[2].icon}`" alt />
              <p
                :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']"
              >{{ TechnologyData[2].title }}</p>
              <div class="bg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  props: ["TechnologyData"],
  data() {
    return {
      // Module_title: { name: "Technology", more: true, color: "#fff",zhTitle:'Science for SDGs',enTitle:'Science for SDGs' }
    };
  },
  computed: {
    Module_title: function() {
      return {
        name: "Technology",
        color: "#fff",
        more: true,
        ehTitle: this.$t("Nav.Menu.Science"),
        zhTitle: this.$t("Nav.Menu.Science")
      };
    }
  },
  filters: {
    formatTime: function(value, language, zhNum, enNum) {
      var msg = value.replace(/<\/?[^>]*>/g, " "); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      return msg.slice(0, zhNum).concat("......");
      // if (language == "zh") {
      //   return msg.slice(0, zhNum).concat("......");
      // } else {
      //   return msg.slice(0, enNum).concat("...");
      // }
    }
  },
  methods: {
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    }
  },
  components: {
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue")
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .zhFamilytitle {
    font-family: $zhFamily;
    line-height: 26px;
    // font-size: 30px;
    // line-height: 32px;
  }
  .enfamilytitle {
    font-family: $enfamilytitle;
    // font-size: 30px;
    // line-height: 32px;
  }
  .Technology2 {
    background: rgba(6, 108, 172, 1);
    margin-top: 60px;
    // background: 'url(' + require('../../../assets/image/Index/Society2.jpg') + ')';
    width: 100%;
    height: 764px;
    .Technology_con_bg {
      width: 100%;
      height: 100%;
      background-attachment: fixed !important;
      background: url("../../../assets/image/Index/Technology_bg.png") no-repeat;
      background-size: 100% 100%;
      .Technology_center {
        overflow: hidden;
        width: 1200px;
        height: 724px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: column;
        .Technology_box {
          height: 602px;
          overflow: hidden;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          background: #fff;
          .Technology_box_left {
            width: 850px;
            height: 602px;
            display: flex;
            flex-direction: column;
            .left_top_box {
              cursor: pointer;
              // flex: 1;
              width: 100%;
              height: 450px;
              overflow: hidden;
              position: relative;

              .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.1);
                transition: 0.2s;
              }
              &:hover .bg {
                background: rgba(0, 0, 0, 0);
                transform: scale(1.1);
                transition: 0.2s;
              }
              &:hover img {
                transform: scale(1.1);
                transition: 0.4s;
              }
              // &:hover p {
              //   color: rgba(43, 196, 238, 1);
              // }
              img {
                width: 100%;
                height: 100%;
                transition: 0.4s;
                object-fit: cover;
              }
              p {
                z-index: 1;
                // background: rgba(0, 0, 0, 0.7);
                position: absolute;
                padding: 20px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                color: #fff;
                font-weight: 600;
                font-size: 26px;
              }
            }
            .left_bottom_box {
              background: rgba(246, 246, 246, 1);
              max-height: 190px;
              height: 190px;
              padding: 10px 0;
              width: 100%;
              display: flex;
              flex-direction: column;
              .latest {
                display: flex;
                flex-direction: row;
                align-items: center;
                //   position: relative;

                height: 50px;
                line-height: 50px;
                .latest_circle {
                  // margin-top: 10px;
                  margin-left: 10px;
                  width: 40px;
                  height: 40px;
                  position: relative;
                  .pulse {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    background: #066cac;
                    border-radius: 50%;
                    box-shadow: 0 0 0 0 #066cac;
                    // margin: 10px;
                    height: 20px;
                    width: 20px;
                    transform: scale(1);
                  }
                  .dot {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    transform: scale(1);
                    animation: circle 2s infinite;
                    opacity: 0;
                    background: #066cac;
                    border-radius: 50%;
                    box-shadow: 0 0 0 0 #066cac;
                    height: 20px;
                    width: 20px;
                  }
                }
                .latest_text {
                  font-weight: 600;
                  font-size: 14px;
                  color: #066cac;
                  height: 50px;
                }
              }
              .latest_other {
                height: 150px;
                display: flex;
                flex-direction: row;
                padding: 0 10px;
                .latest_other_box {
                  flex: 1;
                  margin-right: 10px;
                  .latest_other_box_img {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    flex: row;
                    align-items: flex-start;
                    &:hover p {
                      color: rgba(43, 196, 238, 1);
                    }
                    img {
                      border-radius: 8px;
                      width: 80px;
                      height: 80px;
                      object-fit: cover;
                    }
                    p {
                      padding: 0 6px;
                      font-size: 14px;
                      line-height: 18px;
                      font-weight: 600;
                      color: #000;
                    }
                  }
                }
              }
            }
          }
          .Technology_box_right {
            width: 350px;
            height: 602px;
            background: red;
            .Technology_box_right_top {
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(30, 115, 113, 0.6);
                transition: 0.2s;
              }
              &:hover .bg {
                background: rgba(30, 115, 113, 0);
                transform: scale(1.1);
                transition: 0.2s;
              }
            }
            .Technology_box_right_bottom {
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(124, 187, 102, 0.6);
                transition: 0.2s;
              }
              &:hover .bg {
                background: rgba(124, 187, 102, 0);
                transform: scale(1.1);
                transition: 0.2s;
              }
            }
            .Technology_box_right_top,
            .Technology_box_right_bottom {
              height: 50%;
              width: 100%;
              cursor: pointer;
              overflow: hidden;
              position: relative;

              &:hover img {
                transform: scale(1.1);
                transition: 0.4s;
              }
              // &:hover p {
              //   color: rgba(43, 196, 238, 1);
              // }
              img {
                transition: 0.4s;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              p {
                // background: rgba(0, 0, 0, 0.7);
                position: absolute;
                padding: 20px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                color: #fff;
                font-weight: 600;
                font-size: 16px;
                z-index: 1;
              }
            }
          }
        }
      }

      .Technology_box {
        flex: 1;
        display: flex;
        flex-direction: row;
        .Technology_box_left {
          cursor: pointer;
          width: 800px;
          height: 530px;
          .Technology_img_box {
            position: relative;
            height: 100%;
            width: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            p {
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              padding: 20px;
              bottom: 0px;
              left: 0px;
              right: 0px;
              color: #fff;
              font-weight: 600;
              font-size: 26px;
            }
          }
        }
        .Technology_box_right {
          flex: 1;
          display: flex;
          flex-direction: column;
          .Technology_img_box {
            height: 265px;
            width: 100%;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            p {
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              padding: 10px;
              bottom: 0px;
              right: 0;
              left: 0px;
              color: #fff;
              font-weight: 600;
              font-size: 16px;
            }
          }
        }
        @-webkit-keyframes circle {
          /* Safari and Chrome */

          from {
            opacity: 1;

            -webkit-transform: scale(1);
          }

          to {
            opacity: 0;
            -webkit-transform: scale(2);
          }
        }

        .Technology_box_content {
          cursor: pointer;
          margin: 0 10px;
          // background: #ccc;
          width: 386px;
          height: 453px;

          .Technology_img_box {
            position: relative;
            width: 386px;
            height: 240px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              overflow: hidden;
              object-fit: cover;
            }
          }
          .Technology_text {
            width: 100%;
            height: 213px;
            background: #fff;
            color: #333333;
            border-radius: 0px 0px 0px 30px;
            position: relative;
            .Technology_text_title {
              // height: 90px;
              padding: 20px 20px 0px 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              //   height: 33px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #333333;
              // line-height: 33px;
            }
            .Technology_text_content {
              word-wrap: break-word;
              word-break: normal;
              letter-spacing: 0px;
              padding: 10px 20px 0;
              line-height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            .open {
              transition: 0.2s;
              cursor: pointer;
              position: absolute;
              bottom: 25px;
              right: 36px;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              // background: #0070ff;
              border: 1px solid #0070ff;
              text-align: right;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              i {
                transition: 0.2s;
                font-size: 14px;
                margin-left: 2px;
                font-weight: 600;
                color: #0070ff;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
    .zhFamilytitle {
    font-family: $zhFamily;
    line-height: 26px;
    // font-size: 30px;
    // line-height: 32px;
  }
  .enfamilytitle {
    font-family: $enfamilytitle;
    // font-size: 30px;
    // line-height: 32px;
  }
  .Technology2 {
    background: rgba(6, 108, 172, 1);
    margin-top: 60px;
    // background: 'url(' + require('../../../assets/image/Index/Society2.jpg') + ')';
    width: 100%;
    height: 764px;
    .Technology_con_bg {
      width: 100%;
      height: 100%;
      background-attachment: fixed !important;
      background: url("../../../assets/image/Index/Technology_bg.png") no-repeat;
      background-size: 100% 100%;
      .Technology_center {
        overflow: hidden;
        width: 1200px;
        height: 724px;
        margin: 20px auto 0;
        display: flex;
        flex-direction: column;
        .Technology_box {
          height: 602px;
          overflow: hidden;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          background: #fff;
          .Technology_box_left {
            width: 850px;
            height: 602px;
            display: flex;
            flex-direction: column;
            .left_top_box {
              cursor: pointer;
              // flex: 1;
              width: 100%;
              height: 450px;
              overflow: hidden;
              position: relative;

              .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.1);
                transition: 0.2s;
              }
              &:hover .bg {
                background: rgba(0, 0, 0, 0);
                transform: scale(1.1);
                transition: 0.2s;
              }
              &:hover img {
                transform: scale(1.1);
                transition: 0.4s;
              }
              // &:hover p {
              //   color: rgba(43, 196, 238, 1);
              // }
              img {
                width: 100%;
                height: 100%;
                transition: 0.4s;
                object-fit: cover;
              }
              p {
                z-index: 1;
                // background: rgba(0, 0, 0, 0.7);
                position: absolute;
                padding: 20px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                color: #fff;
                font-weight: 600;
                font-size: 26px;
              }
            }
            .left_bottom_box {
              background: rgba(246, 246, 246, 1);
              max-height: 190px;
              height: 190px;
              padding: 10px 0;
              width: 100%;
              display: flex;
              flex-direction: column;
              .latest {
                display: flex;
                flex-direction: row;
                align-items: center;
                //   position: relative;

                height: 50px;
                line-height: 50px;
                .latest_circle {
                  // margin-top: 10px;
                  margin-left: 10px;
                  width: 40px;
                  height: 40px;
                  position: relative;
                  .pulse {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    background: #066cac;
                    border-radius: 50%;
                    box-shadow: 0 0 0 0 #066cac;
                    // margin: 10px;
                    height: 20px;
                    width: 20px;
                    transform: scale(1);
                  }
                  .dot {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    transform: scale(1);
                    animation: circle 2s infinite;
                    opacity: 0;
                    background: #066cac;
                    border-radius: 50%;
                    box-shadow: 0 0 0 0 #066cac;
                    height: 20px;
                    width: 20px;
                  }
                }
                .latest_text {
                  font-weight: 600;
                  font-size: 14px;
                  color: #066cac;
                  height: 50px;
                }
              }
              .latest_other {
                height: 150px;
                display: flex;
                flex-direction: row;
                padding: 0 10px;
                .latest_other_box {
                  flex: 1;
                  margin-right: 10px;
                  .latest_other_box_img {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    flex: row;
                    align-items: flex-start;
                    &:hover p {
                      color: rgba(43, 196, 238, 1);
                    }
                    img {
                      border-radius: 8px;
                      width: 80px;
                      height: 80px;
                      object-fit: cover;
                    }
                    p {
                      padding: 0 6px;
                      font-size: 14px;
                      line-height: 18px;
                      font-weight: 600;
                      color: #000;
                    }
                  }
                }
              }
            }
          }
          .Technology_box_right {
            width: 350px;
            height: 602px;
            background: red;
            .Technology_box_right_top {
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(30, 115, 113, 0.6);
                transition: 0.2s;
              }
              &:hover .bg {
                background: rgba(30, 115, 113, 0);
                transform: scale(1.1);
                transition: 0.2s;
              }
            }
            .Technology_box_right_bottom {
              .bg {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(124, 187, 102, 0.6);
                transition: 0.2s;
              }
              &:hover .bg {
                background: rgba(124, 187, 102, 0);
                transform: scale(1.1);
                transition: 0.2s;
              }
            }
            .Technology_box_right_top,
            .Technology_box_right_bottom {
              height: 50%;
              width: 100%;
              cursor: pointer;
              overflow: hidden;
              position: relative;

              &:hover img {
                transform: scale(1.1);
                transition: 0.4s;
              }
              // &:hover p {
              //   color: rgba(43, 196, 238, 1);
              // }
              img {
                transition: 0.4s;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              p {
                // background: rgba(0, 0, 0, 0.7);
                position: absolute;
                padding: 20px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                color: #fff;
                font-weight: 600;
                font-size: 16px;
                z-index: 1;
              }
            }
          }
        }
      }

      .Technology_box {
        flex: 1;
        display: flex;
        flex-direction: row;
        .Technology_box_left {
          cursor: pointer;
          width: 800px;
          height: 530px;
          .Technology_img_box {
            position: relative;
            height: 100%;
            width: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            p {
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              padding: 20px;
              bottom: 0px;
              left: 0px;
              right: 0px;
              color: #fff;
              font-weight: 600;
              font-size: 26px;
            }
          }
        }
        .Technology_box_right {
          flex: 1;
          display: flex;
          flex-direction: column;
          .Technology_img_box {
            height: 265px;
            width: 100%;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            p {
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              padding: 10px;
              bottom: 0px;
              right: 0;
              left: 0px;
              color: #fff;
              font-weight: 600;
              font-size: 16px;
            }
          }
        }
        @-webkit-keyframes circle {
          /* Safari and Chrome */

          from {
            opacity: 1;

            -webkit-transform: scale(1);
          }

          to {
            opacity: 0;
            -webkit-transform: scale(2);
          }
        }

        .Technology_box_content {
          cursor: pointer;
          margin: 0 10px;
          // background: #ccc;
          width: 386px;
          height: 453px;

          .Technology_img_box {
            position: relative;
            width: 386px;
            height: 240px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              overflow: hidden;
              object-fit: cover;
            }
          }
          .Technology_text {
            width: 100%;
            height: 213px;
            background: #fff;
            color: #333333;
            border-radius: 0px 0px 0px 30px;
            position: relative;
            .Technology_text_title {
              // height: 90px;
              padding: 20px 20px 0px 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              //   height: 33px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #333333;
              // line-height: 33px;
            }
            .Technology_text_content {
              word-wrap: break-word;
              word-break: normal;
              letter-spacing: 0px;
              padding: 10px 20px 0;
              line-height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            .open {
              transition: 0.2s;
              cursor: pointer;
              position: absolute;
              bottom: 25px;
              right: 36px;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              // background: #0070ff;
              border: 1px solid #0070ff;
              text-align: right;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              i {
                transition: 0.2s;
                font-size: 14px;
                margin-left: 2px;
                font-weight: 600;
                color: #0070ff;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .Technology2 {
    background: rgba(6, 108, 172, 1);
    // margin-top: 60px;
    // background: 'url(' + require('../../../assets/image/Index/Society2.jpg') + ')';
    width: 100%;
    // height: 764px;
    .Technology_con_bg {
      width: 100%;
      height: 100%;
      background-attachment: fixed !important;
      background: url("../../../assets/image/Index/Technology_bg.png") no-repeat;
      background-size: 100% 100%;
      .Technology_center {
        .Technology_center_title {
          padding: 0 10px;
        }

        overflow: hidden;
        display: flex;
        flex-direction: column;
        .Technology_box {
          // height: 602px;
          overflow: hidden;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          background: #fff;
          .Technology_box_left {
            .left_top_box {
              cursor: pointer;
              // flex: 1;
              width: 100%;
              height: 360px;
              overflow: hidden;
              position: relative;
              // &:hover img {
              //   transform: scale(1.1);
              //   transition: 0.4s;
              // }
              // &:hover p {
              //   color: rgba(43, 196, 238, 1);
              // }
              img {
                width: 100%;
                height: 100%;
                transition: 0.4s;
                object-fit: cover;
              }
              p {
                background: rgba(0, 0, 0, 0.7);
                position: absolute;
                padding: 20px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                color: #fff;
                font-weight: 600;
                font-size: 20px;
              }
            }
          }
          .Technology_box_right {
            background: red;
            .Technology_box_right_top,
            .Technology_box_right_bottom {
              height: 360px;
              width: 100%;
              cursor: pointer;
              overflow: hidden;
              position: relative;

              img {
                transition: 0.4s;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              p {
                background: rgba(0, 0, 0, 0.7);
                position: absolute;
                padding: 20px;
                bottom: 0px;
                left: 0px;
                right: 0px;
                color: #fff;
                font-weight: 600;
                font-size: 16px;
              }
            }
          }
        }
      }

      .Technology_box {
        flex: 1;
        display: flex;
        flex-direction: row;
        .Technology_box_left {
          cursor: pointer;

          .Technology_img_box {
            position: relative;
            height: 100%;
            width: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            p {
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              padding: 20px;
              bottom: 0px;
              left: 0px;
              right: 0px;
              color: #fff;
              font-weight: 600;
              font-size: 26px;
            }
          }
        }
        .Technology_box_right {
          flex: 1;
          display: flex;
          flex-direction: column;
          .Technology_img_box {
            height: 265px;
            width: 100%;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
            p {
              background: rgba(0, 0, 0, 0.7);
              position: absolute;
              padding: 10px;
              bottom: 0px;
              right: 0;
              left: 0px;
              color: #fff;
              font-weight: 600;
              font-size: 16px;
            }
          }
        }
        @-webkit-keyframes circle {
          /* Safari and Chrome */

          from {
            opacity: 1;

            -webkit-transform: scale(1);
          }

          to {
            opacity: 0;
            -webkit-transform: scale(2);
          }
        }

        .Technology_box_content {
          cursor: pointer;
          margin: 0 10px;
          // background: #ccc;
          width: 386px;
          height: 453px;

          .Technology_img_box {
            position: relative;
            width: 386px;
            height: 240px;

            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              overflow: hidden;
              object-fit: cover;
            }
          }
          .Technology_text {
            width: 100%;
            height: 213px;
            background: #fff;
            color: #333333;
            border-radius: 0px 0px 0px 30px;
            position: relative;
            .Technology_text_title {
              // height: 90px;
              padding: 20px 20px 0px 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              //   height: 33px;
              font-size: 24px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #333333;
              // line-height: 33px;
            }
            .Technology_text_content {
              word-wrap: break-word;
              word-break: normal;
              letter-spacing: 0px;
              padding: 10px 20px 0;
              line-height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
            }

            .open {
              transition: 0.2s;
              cursor: pointer;
              position: absolute;
              bottom: 25px;
              right: 36px;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              // background: #0070ff;
              border: 1px solid #0070ff;
              text-align: right;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              i {
                transition: 0.2s;
                font-size: 14px;
                margin-left: 2px;
                font-weight: 600;
                color: #0070ff;
              }
            }
          }
        }
      }
    }
  }
}
</style>
